// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      activityModelOptions: [
        "NA",
        "Sample",
        "Area",
        "Asset",
        "Risk"
      ],
      // eslint-disable-next-line
      resultsOwnerOptions: [
        "O",
        "M",
        "E",
        "L",
        "V"
      ],
      // eslint-disable-next-line
      resultsCategoryOptions: [
        "General", // general
        "Regulatory",
        "Standard", // standard
        "Lab",
        "Special" // special
      ],
      // eslint-disable-next-line
      resultsTypeOptions: [
        "Inspect",
        "Test",
        "Sample"
      ],
      // eslint-disable-next-line
      resultTestOptions: [
        "Number",
        "P/F"
      ],
    };
  }
};
